import { Cross, Phone, Mail, MapPin } from "lucide-react";
import { scrollToSection, requestLeadType } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28">
        <div className="flex flex-col justify-between gap-12 lg:flex-row lg:items-end">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.4em] text-gold">
              Seraph Roofing
            </p>
            <p className="mt-4 font-serif text-5xl font-medium italic leading-tight tracking-tight text-white md:text-7xl">
              Above the Rest,
              <br />
              Every Time.
            </p>
          </div>
          <button
            data-testid="footer-cta-btn"
            onClick={() => {
              requestLeadType("inspection");
              scrollToSection("#contact");
            }}
            className="self-start bg-gold px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] text-ink transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold-light lg:self-auto"
          >
            Get My Free Inspection
          </button>
        </div>

        <div className="mt-16 grid gap-10 border-t border-white/10 pt-12 md:grid-cols-3">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-white/40">
              Contact
            </p>
            <a
              data-testid="footer-phone-link"
              href="tel:+13175169317"
              className="mt-4 flex items-center gap-3 text-sm text-white/75 transition-colors duration-300 hover:text-gold"
            >
              <Phone className="h-4 w-4 text-gold" /> (317) 516-9317
            </a>
            <a
              data-testid="footer-email-link"
              href="mailto:seraphroofing@gmail.com"
              className="mt-3 flex items-center gap-3 text-sm text-white/75 transition-colors duration-300 hover:text-gold"
            >
              <Mail className="h-4 w-4 text-gold" /> seraphroofing@gmail.com
            </a>
            <p className="mt-3 flex items-center gap-3 text-sm text-white/45">
              <MapPin className="h-4 w-4 text-gold" /> Serving Central Indiana
            </p>
          </div>
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-white/40">
              Services
            </p>
            <p className="mt-4 text-sm leading-loose text-white/55">
              Roofing &middot; Repairs &middot; Replacement
              <br />
              Siding &middot; Gutters &middot; Storm Restoration
              <br />
              Insurance Restoration &middot; Emergency Repairs
            </p>
          </div>
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-white/40">
              Our Promise
            </p>
            <p className="mt-4 text-sm leading-relaxed text-white/55">
              Honest communication. Quality workmanship. Dependable service — built on faith,
              built to last.
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-gold/80">
              <Cross className="h-3.5 w-3.5" /> A Collisions 323 partner &middot; Colossians 3:23
            </p>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 text-[11px] uppercase tracking-[0.25em] text-white/35 md:flex-row">
          <span>&copy; 2026 Seraph Roofing. All rights reserved.</span>
          <span>Faith &middot; Excellence &middot; Protection</span>
        </div>
      </div>
    </footer>
  );
}
